import React from "react";

//import Css
import classes from "./TeamMember.module.css";
import classesDark from "./TeamMemberDark.module.css";

//import icons
import * as FiIcons from "react-icons/fi";
import { RiTwitterXLine } from "react-icons/ri";

const TeamMember = (props) => {
  let styles = classes;
  if (props.theme) {
    styles = classes;
  } else {
    styles = classesDark;
  }

  let cardClassDomain, cardImgDomain, svgClassDomain;
  switch (props.domain) {
    case 8:
      cardClassDomain = styles.card0;
      cardImgDomain = styles.cardImg0;
      // svgClassDomain = styles.svgDomain1;
      break;
    case 1:
      cardClassDomain = styles.card1;
      cardImgDomain = styles.cardImg1;
      svgClassDomain = styles.svgDomain1;
      break;
    case 2:
      cardClassDomain = styles.card2;
      cardImgDomain = styles.cardImg2;
      svgClassDomain = styles.svgDomain2;
      break;
    case 3:
      cardClassDomain = styles.card3;
      cardImgDomain = styles.cardImg3;
      svgClassDomain = styles.svgDomain3;
      break;
    case 4:
      cardClassDomain = styles.card4;
      cardImgDomain = styles.cardImg4;
      svgClassDomain = styles.svgDomain4;
      break;
    case 5:
      cardClassDomain = styles.card5;
      cardImgDomain = styles.cardImg5;
      svgClassDomain = styles.svgDomain5;
      break;
    default:
      break;
  }

  return (
    <div className={styles.TeamMember}>
      <div className={`${styles.card} ${cardClassDomain}`}>
        <div>
          <div className={`${styles.cardImg} ${cardImgDomain}`}>
            <img
              src={props.image}
              alt={props.cardName}
              style={
                props.imageStyle
                  ? props.imageStyle
                  : props.objectPosition
                  ? { objectPosition: props.objectPosition }
                  : undefined
              }
            />
          </div>
          <div className={styles.cardBody}>
            <h1 className={styles.cardName}>{props.cardName}</h1>
            <h2 className={styles.cardDesignation}>{props.cardDesignation}</h2>
            {props.domain !== 8 && (
              <ul className={styles.linkList}>
                {props.links?.github && props.links.github !== "/" && (
                  <li>
                    <a
                      href={props.links.github.startsWith("http") ? props.links.github : `https://${props.links.github}`}
                      target={"_blank"}
                      rel="noopener noreferrer"
                      aria-label="GitHub"
                    >
                      <FiIcons.FiGithub className={svgClassDomain} />
                    </a>
                  </li>
                )}
                {props.links?.linkedin && props.links.linkedin !== "/" && (
                  <li>
                    <a
                      href={props.links.linkedin.startsWith("http") ? props.links.linkedin : `https://${props.links.linkedin}`}
                      target={"_blank"}
                      rel="noopener noreferrer"
                      aria-label="LinkedIn"
                    >
                      <FiIcons.FiLinkedin className={svgClassDomain} />
                    </a>
                  </li>
                )}
                {props.links?.twitter && props.links.twitter !== "/" && (
                  <li>
                    <a
                      href={props.links.twitter.startsWith("http") ? props.links.twitter : `https://${props.links.twitter}`}
                      target={"_blank"}
                      rel="noopener noreferrer"
                      aria-label="Twitter"
                    >
                      <RiTwitterXLine className={svgClassDomain} />
                    </a>
                  </li>
                )}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMember;
